<template>
  <input :id="field.name"
         :name="field.name"
         :data-vv-as="field.description.replace(/\./g, '')"
         :value="value"
         type="text"
         class="tim form-control"
         data-provide="timepicker"
         :data-default-time="value || 'current'"
         v-validate="{required: required && !field.hide}"
         :readonly="locked"
  />
</template>

<script>
import { onMounted } from 'vue';

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    }
  },

  emits: ['input', 'validate'],

  setup(props, { emit }) {
    onMounted(() => {
      $('#' + props.field.name).on('changeTime.timepicker', (e) => {
        emit('input', e.target.value);
        emit('validate');
      })
    })
    return {}
  }
}
</script>

<style scoped lang="scss">
@import '~/static/global/plugins/bootstrap-timepicker/css/bootstrap-timepicker.min.css';
</style>



// WEBPACK FOOTER //
// TimeRender.vue?d40b492e